import React, { useState, useRef, useEffect } from "react";
import { Stack } from "@mui/material";

import { HubHookFormWrapper, HubIcon } from "../../";
import { useDebounce, useGetSearchData } from "../../../hooks";
import SearchResults from "./SearchResults";
import { StyledHubHookFormInput } from "./styles";

export const SearchNavBar = ({ object = "", inputProps = {}, customOnClick }) => {
  const [value, setValue] = useState();
  const [isFocused, setIsFocused] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const stackRef = useRef();

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useGetSearchData(value);

  const handleClickOutside = (event) => {
    if (stackRef.current && !stackRef.current.contains(event.target)) {
      setIsFocused(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleChange = (e) => {
    const newValue = e?.target?.value;
    setInputValue(newValue);
    debouncedSetValue(newValue);
  };
  
  const handleChangeDebounced = (newValue) => {
    setValue(newValue);
  };
  
  const onClose = () => {
    setIsFocused(false);
  };

  const debouncedSetValue = useDebounce(handleChangeDebounced, 500);

  const showResults = isFocused && value;

  return (
    <Stack ref={stackRef} sx={{ flexGrow: 1, width: "auto" }}>
      <HubHookFormWrapper sx={{ position: "relative" }} onSubmit={() => {}}>
        <StyledHubHookFormInput
          name="searchQuery"
          placeholder="Search..."
          startAdornment={<HubIcon icon="Search" />}
          onChange={handleChange}
          onFocus={() => setIsFocused(true)}
          disableHelperText
          value={inputValue}
          {...inputProps}
        />
        {showResults && (
          <SearchResults
            data={data}
            onClose={onClose}
            customOnClick={customOnClick}
            fetchNextPage={fetchNextPage}
            hasNextPage={hasNextPage}
            isFetchingNextPage={isFetchingNextPage}
            searchQuery={value}
          />
        )}
      </HubHookFormWrapper>
    </Stack>
  );
};

export default SearchNavBar;
